/*
  Solution idea source: https://redux.js.org/recipes/structuring-reducers/reusing-reducer-logic/
*/

import { equals } from 'ramda';
import { addDomainEntity, addDomainEntityId } from '.';

// prettier-ignore
export function createAllIdsTypeReducer(TYPE, initialState = []) { //NOSONAR
  // prettier-ignore
  return function allIdsReducer(state = initialState, { type, payload }) { //NOSONAR
    switch (type) { //NOSONAR
      case TYPE:
        const allIds = payload.reduce(addDomainEntityId, []);

        if (!equals(allIds, state)) {
          return allIds;
        }

        return state;

      default:
        return state;
    }
  };
}
// prettier-ignore
export function createEntityMapTypeReducer(TYPE, initialState = {}) { //NOSONAR
  // prettier-ignore
  return function entityReducer(state = initialState, { type, payload }) { //NOSONAR
    switch (type) { //NOSONAR
      case TYPE:
        const entityMap = payload.reduce(addDomainEntity, {});

        if (!equals(entityMap, state)) {
          return entityMap;
        }

        return state;

      default:
        return state;
    }
  };
}
